// User-facing text for failed Event / occurrence requests.
//
// Structured rejections are { code, detail } (OccurrenceEditError on the
// backend); their `detail` is already written for people, so it's shown as
// is. DRF field errors are { field: [messages] }.

export function errorCode(err) {
  return err?.response?.data?.code ?? null;
}

export function isNotFound(err) {
  return err?.response?.status === 404;
}

const FIELD_LABELS = {
  starts_at: "Start",
  ends_at: "End",
  recurrence_ends_at: "Repeat until",
  occurrence_id: "Occurrence",
  non_field_errors: "",
};

function fieldErrorText(data) {
  const parts = [];
  for (const [field, value] of Object.entries(data)) {
    const messages = (Array.isArray(value) ? value : [value]).filter((m) => typeof m === "string");
    if (messages.length === 0) continue;
    const label = field in FIELD_LABELS ? FIELD_LABELS[field] : field.replace(/_/g, " ");
    parts.push(label ? `${label}: ${messages.join(" ")}` : messages.join(" "));
  }
  return parts.join(" ");
}

export function eventErrorMessage(err, fallback = "Something went wrong. Please try again.") {
  const res = err?.response;
  if (!res) return "Couldn't reach the server. Check your connection and try again.";

  const data = res.data;
  if (res.status === 404) return "This event is no longer available.";
  if (res.status === 403) return "Only the event's organizer can do that.";

  if (data && typeof data === "object") {
    if (typeof data.detail === "string" && data.detail) return data.detail;
    const text = fieldErrorText(data);
    if (text) return text;
  }
  return fallback;
}
